import Paragraph from '@tiptap/extension-paragraph';

import { Suggestion } from '../plugins/suggestion/SuggestionPlugin';

export const ParagraphExtension = Paragraph.extend({
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
      }),
    ];
  },
});
